<div class="modal-container">
	<div class="actions">
		<mat-icon (click)="closeClicked()" class="cursor-pointer" matRipple>close</mat-icon>
	</div>

	<form (ngSubmit)="submit()" [formGroup]="myForm" class="chart-point-edit-form">
		@if (isEditEnabled()) {
			<div style="display: flex; flex-direction: column">
				<mat-form-field appearance="fill">
					<mat-label>Enter number</mat-label>
					<input formControlName="value" matInput type="number" />
				</mat-form-field>

				<mat-form-field appearance="fill">
					<mat-label>{{ 'choose_date' | translate }}</mat-label>
					<input [matDatepicker]="picker" formControlName="date" matInput />
					<mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
					<mat-datepicker #picker (opened)="datePickerOpened.set(true)"></mat-datepicker>
				</mat-form-field>
			</div>
		} @else {
			<div class="data-display">
				<div>{{ 'value' | translate }}</div>
				<div class="value">{{ dataPointValue?.value }} {{ unit ?? '' }}</div>
				<div>{{ 'date' | translate }}</div>
				<div class="value">{{ dataPointValue?.created | date: 'MMM d, y, HH:mm' }}</div>
				<div>{{ 'updated_by' | translate }}</div>
				<div class="value user">
					<au-round-avatar
						[data]="dataPointValue?.createdBy"
						[size]="35"
					></au-round-avatar>
					{{ dataPointValue?.createdBy?.firstName }}
					{{ dataPointValue?.createdBy?.lastName }}
				</div>
			</div>
		}

		<div class="form-actions">
			<button
				(click)="deleteClicked()"
				class="au-mat-flat-stroke au-mat-btn-xs error-btn uppercase"
				matRipple
			>
				{{ 'delete' | translate }}
			</button>

			@if (isEditEnabled()) {
				<div class="submit-cancel-buttons">
					<button
						[disabled]="!myForm.valid"
						class="au-mat-flat-stroke au-mat-btn-xs save-button uppercase"
						matRipple
						type="submit"
					>
						{{ 'submit' | translate }}
					</button>
				</div>
			}
		</div>
	</form>
</div>
